import { render, staticRenderFns } from "./AddFeatureRequestModal.vue?vue&type=template&id=480fc790&scoped=true&"
import script from "./AddFeatureRequestModal.vue?vue&type=script&lang=js&"
export * from "./AddFeatureRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFeatureRequestModal.vue?vue&type=style&index=0&id=480fc790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fc790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480fc790')) {
      api.createRecord('480fc790', component.options)
    } else {
      api.reload('480fc790', component.options)
    }
    module.hot.accept("./AddFeatureRequestModal.vue?vue&type=template&id=480fc790&scoped=true&", function () {
      api.rerender('480fc790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeatureRequests/AddFeatureRequestModal.vue"
export default component.exports